export const atLeastOneUnicodeLetter = (input) => {
  return /\p{L}/u.test(input)
}

export const userNameAllowedCharacters = (input) => {
  return /^[\p{L}\d \-'.]+$/u.test(input)
}

export const companyURLPrefixAllowedCharacters = (input) => {
  return /^[a-z0-9-]+$/.test(input)
}
export const noSpacesAtEdges = (input) => {
  return !/^\s|\s$/.test(input)
}
